import styled from 'styled-components'

export const Container = styled.div`
  height: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
`

export const Title = styled.span`
  cursor: pointer;
  color: var(--Foreground-Neutral-faded, #4d5874);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;

  &:hover {
    color: var(--Foreground-Neutral, #14171f);
  }

  @media (max-width: ${({ theme }) => theme.responsive.mobile.valueString}) {
    color: var(--foreground-neutral, #14171f);
    font-size: 16px;
    font-weight: 400;
    line-height: 28px;
  }
`

export const Name = styled.span`
  color: var(--Foreground-Neutral, #14171f);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;

  @media (max-width: ${({ theme }) => theme.responsive.mobile.valueString}) {
    font-size: 16px;
    line-height: 28px;
  }
`
